import {Web3Store} from "../stores/web3Store";
import mythPassWhitelist from "../data/prod/whitelist/whitelist-mythPass.json";
import logger from "../logger";
import {getWalletProof} from "../utils/merkeltree";

interface IPassAvailableForMinting {
    classicAvailable: boolean,
    goldenAvailableAirdropNums: number[]
}

export default class MythServerApi {

    public async getAvailableForMinting(web3Store: Web3Store): Promise<IPassAvailableForMinting> {
        const passAvailableForMinting: IPassAvailableForMinting = {
            classicAvailable: false,
            goldenAvailableAirdropNums: []
        };
        try {
            if (web3Store.mythPass && web3Store.account) {
                const airdropNums: number[] = [];
                const proofs: string[][] = [];

                for (let i = 0; i < mythPassWhitelist.goldenPassWhitelist.length; i++) {
                    airdropNums.push(mythPassWhitelist.goldenPassWhitelist[i].airdropNum);
                    proofs.push(getWalletProof(web3Store.account, mythPassWhitelist.goldenPassWhitelist[i].whitelist));
                }

                const result = await web3Store.mythPass.getAvailableForMinting(airdropNums, proofs);
                result.forEach((value, index) => {
                    if(value > 0){
                        passAvailableForMinting.goldenAvailableAirdropNums.push(airdropNums[index]);
                    }
                });

                const freeMinted = await web3Store.mythPass.freeMintList(web3Store.account);
                passAvailableForMinting.classicAvailable = !freeMinted;
            }
        } catch (ex) {
            logger.error(ex);
        }

        return passAvailableForMinting;
    }

}
